class form_data {

    constructor(id) {
        this.id = id;
    }

    get() {
        var serialized = $('#' + this.id).serializeAll();

        var form_data = {};
        for (var i = 0; i < serialized.length; i++) {
            form_data[serialized[i].name] = serialized[i].value;
        }

        return form_data;
    }

    set_cookie_data_to_form(cookie_data) {
        // Loop through each property in cookie_data
        for (var key in cookie_data) {

            if (cookie_data.hasOwnProperty(key)) {
                let formElementName = cookie_data[key]['name'];
                let formElementValue = cookie_data[key]['value'];

                // Find the form element by its name attribute and set its value
                // mp_rod_type and mp_cyl_type are special cases that should not be set to the form
                if (formElementName != 'mp_rod_type' && formElementName != 'mp_cyl_type') {
                    $('[name="' + formElementName + '"]').val(formElementValue);
                }
            }
        }
    }

}